import React, { useState } from "react";

export default function StudentForm() {
  const [formData, setFormData] = useState({
    board: "CBSE",
    passingYear12: "2020",
    stream: "Science",
    percentage12: "85%",
    universityUG: "XYZ University",
    passingYearUG: "2023",
    subjectUG: "Computer Science",
    percentageUG: "80%",
    universityPG: "ABC University",
    passingYearPG: "2025",
    subjectPG: "Data Science",
    percentagePG: "85%",
    preferredDegree: "Master's",
    preferredCountry: "USA",
    preferredField: "Artificial Intelligence",
    preferredIntake: "Fall",
    preferredIntakeYear: "2025",
    workExperience: "Yes",
    givenTest: "Yes",
    testName: "IELTS",
    heardFrom: ["Website", "Friends"],
    otherComments: "Looking forward to applying. ",
  });

  const sectionStyle = {
    backgroundColor: "#a4a3a2",
    padding: "10px",
    marginBottom: "10px",
    fontSize: "18px",
    fontFamily: ' "Poppins", sans-serif',
    fontWeight: "500",
    color: "black",
  };

  const containerStyle = {
    maxWidth: "900px",
    margin: "auto",
    padding: "20px",
    fontFamily: ' "Poppins", sans-serif',
  };

  const tableStyle = {
    width: "100%",
    borderCollapse: "collapse",
    textAlign: "left",
    marginBottom: "20px",
  };

  const thTdStyle2 = {
    width: "50%",
    padding: "8px 12px",
    borderBottom: "1px solid #ddd",
    backgroundColor: "#fff",
    fontSize: "14px",
  };
  const thTdStyle = {
    width: "40%",
    padding: "8px 12px",
    borderBottom: "1px solid #ddd",
    backgroundColor: "#fff",
    fontSize: "14px",
    color: "#f26524",
    fontWeight: "700",
  };

  const clr = {
    color: "#f26524",
    fontWeight: "700",
  };

  const thTdStyle1 = {
    width: "40%",
    padding: "8px 12px",
    borderBottom: "1px solid #ddd",
    backgroundColor: "#fff",
    fontSize: "14px",
  };

  return (
    <div style={containerStyle}>
      <div
        style={{
          background: "#fff",
          color: "#000",
          borderRadius: "5px",
          boxShadow: "0 0 10px rgba(0,0,0,0.2)",
        }}
      >
        <h2
          style={{
            padding: "10px 20px",
            backgroundColor: "#211762 ", // #f26524
            color: "#fff",
            textAlign: "center",
          }}
        >
          Student Information
        </h2>

        <div style={{ marginTop: "20px" }}>
          <h4 style={sectionStyle}>Personal Details</h4>
          <table style={tableStyle}>
            <tbody>
              <tr>
                <td style={thTdStyle2}>
                  Branch: <span style={clr}>{formData.branch} </span>
                </td>
                <td style={thTdStyle2}>
                  {" "}
                  Medium : <span style={clr}>{formData.medium} </span>
                </td>
              </tr>
              <tr>
                <td style={thTdStyle2}>
                  Event: <span style={clr}>{formData.eventId} </span>
                </td>
                <td style={thTdStyle2}>
                  {" "}
                  Email Address:<span style={clr}>{formData.email} </span>
                </td>
              </tr>

              <tr>
                <td style={thTdStyle2}>
                  {" "}
                  First Name:<span style={clr}> {formData.firstName}</span>
                </td>
                <td style={thTdStyle2}>
                  Last Name: <span style={clr}>{formData.lastName} </span>
                </td>
              </tr>

              <tr>
                <td style={thTdStyle2}>
                  Phone No:<span style={clr}>{formData.gender} </span>{" "}
                </td>
                <td style={thTdStyle2}>
                  {" "}
                  Date of Birth: <span style={clr}> {formData.dob}</span>
                </td>
              </tr>

              <tr>
                <td style={thTdStyle2}>
                  Marital Status:
                  <span style={clr}> {formData.maritalStatus}</span>
                </td>
                <td style={thTdStyle2}>
                  Alternate Phone:
                  <span style={clr}> {formData.alternatePhone}</span>
                </td>
              </tr>

              <tr>
                <td style={thTdStyle2}>
                  City:<span style={clr}> {formData.city}</span>
                </td>
                <td style={thTdStyle2}>
                  State:<span style={clr}> {formData.state}</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div>
          <h4 style={sectionStyle}>12th Details</h4>
          <table style={tableStyle}>
            <tbody>
              <tr>
                <td style={thTdStyle1}>Board:</td>
                <td style={thTdStyle}>{formData.board}</td>
              </tr>
              <tr>
                <td style={thTdStyle1}>Passing Year:</td>
                <td style={thTdStyle}>{formData.passingYear12}</td>
              </tr>
              <tr>
                <td style={thTdStyle1}>Stream:</td>
                <td style={thTdStyle}>{formData.stream}</td>
              </tr>
              <tr>
                <td style={thTdStyle1}>Percentage:</td>
                <td style={thTdStyle}>{formData.percentage12}</td>
              </tr>
            </tbody>
          </table>
        </div>

        <div>
          <h4 style={sectionStyle}>Bachelor's Details</h4>
          <table style={tableStyle}>
            <tbody>
              <tr>
                <td style={thTdStyle1}>University:</td>
                <td style={thTdStyle}>{formData.universityUG}</td>
              </tr>
              <tr>
                <td style={thTdStyle1}>Passing Year:</td>
                <td style={thTdStyle}>{formData.passingYearUG}</td>
              </tr>
              <tr>
                <td style={thTdStyle1}>Subject:</td>
                <td style={thTdStyle}>{formData.subjectUG}</td>
              </tr>
              <tr>
                <td style={thTdStyle1}>Percentage:</td>
                <td style={thTdStyle}>{formData.percentageUG}</td>
              </tr>
            </tbody>
          </table>
        </div>

        <div>
          <h4 style={sectionStyle}>Master's Details</h4>
          <table style={tableStyle}>
            <tbody>
              <tr>
                <td style={thTdStyle1}>University:</td>
                <td style={thTdStyle}>{formData.universityPG}</td>
              </tr>
              <tr>
                <td style={thTdStyle1}>Passing Year:</td>
                <td style={thTdStyle}>{formData.passingYearPG}</td>
              </tr>
              <tr>
                <td style={thTdStyle1}>Subject:</td>
                <td style={thTdStyle}>{formData.subjectPG}</td>
              </tr>
              <tr>
                <td style={thTdStyle1}>Percentage:</td>
                <td style={thTdStyle}>{formData.percentagePG}</td>
              </tr>
            </tbody>
          </table>
        </div>

        <div>
          <h4 style={sectionStyle}>Preferences</h4>
          <table style={tableStyle}>
            <tbody>
              <tr>
                <td style={thTdStyle1}>Preferred Degree:</td>
                <td style={thTdStyle}>{formData.preferredDegree}</td>
              </tr>
              <tr>
                <td style={thTdStyle1}>Preferred Country:</td>
                <td style={thTdStyle}>{formData.preferredCountry}</td>
              </tr>
              <tr>
                <td style={thTdStyle1}>Preferred Field of Study:</td>
                <td style={thTdStyle}>{formData.preferredField}</td>
              </tr>
              <tr>
                <td style={thTdStyle1}>Preferred Intake:</td>
                <td style={thTdStyle}>{formData.preferredIntake}</td>
              </tr>
            </tbody>
          </table>
        </div>

        <div>
          <h4 style={sectionStyle}>Additional Information</h4>
          <table style={tableStyle}>
            <tbody>
              <tr>
                <td style={thTdStyle1}>Work Experience:</td>
                <td style={thTdStyle}>{formData.workExperience}</td>
              </tr>
              <tr>
                <td style={thTdStyle1}>Given Test:</td>
                <td style={thTdStyle}>{formData.givenTest}</td>
              </tr>
              <tr>
                <td style={thTdStyle1}>Test Name:</td>
                <td style={thTdStyle}>{formData.testName}</td>
              </tr>
              <tr>
                <td style={thTdStyle1}>Heard From:</td>
                <td style={thTdStyle}>{formData.heardFrom.join(", ")}</td>
              </tr>
              <tr>
                <td style={thTdStyle1}>Other Comments:</td>
                <td style={thTdStyle}>{formData.otherComments}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
